import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { v4 as uuid4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
  Tabs,
  Tab,
} from '@material-ui/core';
import HourForm from 'src/components/HourForm';
import orderBy from 'src/utils/arrays';
import Errors from '../../../components/Errors';
import useErrors from '../../../hooks/useErrors';
import DriverService from '../../../services/DriverService';

// utils

const useStyles = makeStyles(() => ({
  root: {},
  tabs: {
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'space-between',
    }
  },
  tab: {
    minWidth: '2rem'
  }
}));

const initialSchedule = {
  Monday: [],
  Tuesday: [],
  Wednesday: [],
  Thursday: [],
  Friday: [],
  Saturday: [],
  Sunday: [],
};

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const CreateDriverForm = ({
  className, onChange, driver, ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [schedule, setSchedule] = useState(initialSchedule);
  const { setErrors } = useErrors();

  const handleChangeTab = (e, value) => setActiveIndex(value);

  const handleRemoveHour = (hours) => {
    setSchedule({
      ...schedule,
      [days[activeIndex]]: schedule?.[days[activeIndex]]?.filter((h) => !(h === hours))
    });
  };

  const addNewSchedule = () => {
    const newSchedule = schedule?.[days[activeIndex]]?.concat({ id: uuid4(), start: '', end: '' });

    setSchedule({
      ...schedule,
      [days[activeIndex]]: newSchedule
    });
  };

  const handleChangeSchedule = (hours) => {
    const newSchedule = orderBy(schedule?.[days[activeIndex]], 'start')
      ?.reduce((array, item) => {
        if (item?.id === hours?.id) {
          return array.concat(hours);
        }
        return array.concat(item);
      }, []);

    setSchedule({
      ...schedule,
      [days[activeIndex]]: newSchedule
    });
  };

  const scheduleIsCompleted = () => {
    let isOK = true;

    days.map((day) => {
      schedule?.[day]?.map((s) => {
        if (isOK) {
          if (s?.start === '' || s?.end === '') {
            isOK = false;
          }
        }
        return s;
      });
      return day;
    });

    return isOK;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = [];
    const data = {
      schedule: {
        Holidays: [],
        ...schedule
      }
    };

    if (!driver?.id) {
      errors.push('No es posible actualizar esta sucursal');
    }

    if (!scheduleIsCompleted()) {
      errors.push('No puede haber horarios sin hora definida');
    }

    setErrors(errors);

    if (errors?.length === 0 && driver?.id) {
      const response = await DriverService.updateSchedule(driver?.id, data);

      if (response?.code === 200) {
        setErrors([]);
        navigate('/app/repartidores', { replace: true });
      } else {
        setErrors(response?.errors === undefined ? [] : response?.errors);
      }
    }
  };

  useEffect(() => {
    if (driver?.schedule) {
      setSchedule(driver?.schedule);
    }
  }, [driver]);

  return (
    <form
      autoComplete="off"
      noValidate
      onSubmit={handleSubmit}
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card>
        <CardHeader
          subheader="La información puede ser editada"
          title={`Horario de ${driver?.first_name} ${driver?.last_name}`}
        />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Tabs value={activeIndex} className={classes?.tabs} onChange={handleChangeTab}>
                <Tab label="Lunes" className={classes?.tab} {...a11yProps(0)} />
                <Tab label="Martes" className={classes?.tab} {...a11yProps(1)} />
                <Tab label="Miércoles" className={classes?.tab} {...a11yProps(2)} />
                <Tab label="Jueves" className={classes?.tab} {...a11yProps(3)} />
                <Tab label="Viernes" className={classes?.tab} {...a11yProps(4)} />
                <Tab label="Sábado" className={classes?.tab} {...a11yProps(5)} />
                <Tab label="Domingo" className={classes?.tab} {...a11yProps(6)} />
              </Tabs>
            </Grid>
          </Grid>
          {
            orderBy(schedule?.[days[activeIndex]], 'start')?.map((hours) => (
              <HourForm
                key={hours?.id}
                hours={hours}
                onChange={handleChangeSchedule}
                onRemove={handleRemoveHour}
              />
            ))
          }
          <Grid container spacing={3}>
            <Box p={2}>
              <Button
                variant="outlined"
                disableElevation
                onClick={addNewSchedule}
              >
                Agregar otro horario
              </Button>
            </Box>
          </Grid>
        </CardContent>
        <Errors time={0} />
        <Divider />
        <Box
          display="flex"
          justifyContent="flex-end"
          p={2}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
          >
            Guardar
          </Button>
        </Box>
      </Card>
    </form>
  );
};

CreateDriverForm.propTypes = {
  className: PropTypes.string,
  hasImage: PropTypes.bool,
  onChange: PropTypes.func,
  driver: PropTypes.shape({
    id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    schedule: PropTypes.object,
  })
};

CreateDriverForm.defaultProps = {
  className: '',
  hasImage: false,
  onChange: () => {},
  driver: {
    id: '',
    first_name: '',
    last_name: '',
    schedule: {},
  }
};

export default CreateDriverForm;
